import { useState } from 'react';
import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/seo';

const FORM_URL = 'https://readdy.ai/api/form/d8sks5cjgj4v45gj7lj0';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    fetch(FORM_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
    })
      .then(() => {
        setSubmitted(true);
        setEmail('');
      })
      .catch(() => setSubmitted(true));
  };

  return (
    <footer className="w-full bg-accent-950 text-white">
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="w-full h-full" style={{
            backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.3) 1px, transparent 1px), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.2) 1px, transparent 1px), radial-gradient(circle at 50% 80%, rgba(255,255,255,0.25) 1px, transparent 1px)',
            backgroundSize: '80px 80px, 100px 100px, 120px 120px',
          }}></div>
        </div>

        <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-8 lg:px-12 py-16 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
            <div>
              <Link to="/" className="font-heading text-2xl md:text-3xl font-bold">
                Mulebuy Spreadsheet<span className="text-accent-400">.</span>
              </Link>
              <form
                data-readdy-form
                id="newsletter-form-footer"
                onSubmit={handleSubmit}
                className="mt-6 flex items-stretch gap-2 max-w-sm"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="flex-1 px-4 py-2.5 text-sm bg-transparent border border-white/20 rounded-full text-white placeholder:text-white/40 focus:outline-none focus:border-white/50 transition-colors font-sans"
                />
                <button
                  type="submit"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-white hover:bg-accent-400 transition-all cursor-pointer flex-shrink-0"
                >
                  <i className="ri-notification-3-line text-sm"></i>
                </button>
              </form>
              {submitted && (
                <p className="mt-3 text-xs text-accent-300 font-sans">Thanks for subscribing!</p>
              )}
              <p className="mt-5 font-heading text-lg md:text-xl text-white/80 leading-relaxed">
                Your Trusted SEO Hub
                <br />
                For Sourcing &amp; Spreadsheets
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {Object.entries(footerLinks).map(([key, links]) => (
                <div key={key}>
                  <h4 className="text-xs font-semibold text-white/60 uppercase tracking-wider mb-3 font-sans">{key}</h4>
                  <ul className="space-y-2">
                    {links.map((link) => (
                      <li key={link.name}>
                        {link.url.startsWith('http') ? (
                          <a
                            href={link.url}
                            target="_blank"
                            rel="noopener nofollow"
                            className="text-sm text-white/50 hover:text-white/80 transition-colors font-sans whitespace-nowrap"
                          >
                            {link.name}
                          </a>
                        ) : link.url.startsWith('/article/') ? (
                          <Link
                            to={link.url}
                            className="text-sm text-white/50 hover:text-white/80 transition-colors font-sans whitespace-nowrap"
                          >
                            {link.name}
                          </Link>
                        ) : (
                          <Link
                            to={link.url}
                            className="text-sm text-white/50 hover:text-white/80 transition-colors font-sans whitespace-nowrap"
                          >
                            {link.name}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="relative z-10 border-t border-white/10">
          <div className="max-w-6xl mx-auto px-6 md:px-8 lg:px-12 py-5">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-white/40 font-sans">
                &copy; 2026 Mulebuy Spreadsheet. All rights reserved.
              </p>
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg border border-white/20 text-white/50 cursor-default">
                  <i className="ri-twitter-x-line text-sm"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-lg border border-white/20 text-white/50 cursor-default">
                  <i className="ri-instagram-line text-sm"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-lg border border-white/20 text-white/50 cursor-default">
                  <i className="ri-linkedin-line text-sm"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-lg border border-white/20 text-white/50 cursor-default">
                  <i className="ri-pinterest-line text-sm"></i>
                </span>
              </div>
              <Link to="/" className="text-xs text-white/40 hover:text-white/60 transition-colors font-sans">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}